import { render, staticRenderFns } from "./NTop.vue?vue&type=template&id=4dc37ed0&scoped=true"
import script from "./NTop.vue?vue&type=script&lang=js"
export * from "./NTop.vue?vue&type=script&lang=js"
import style0 from "./NTop.vue?vue&type=style&index=0&id=4dc37ed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc37ed0",
  null
  
)

export default component.exports